import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagGQ = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M15.217 16.304h33.228C44.913 6.784 35.749 0 25 0A24.919 24.919 0 0 0 7.323 7.323l7.894 8.981Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M15.217 33.696h33.228C44.913 43.216 35.749 50 25 50a24.918 24.918 0 0 1-17.677-7.323l7.894-8.981Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M7.322 7.322c-9.763 9.763-9.763 25.593 0 35.356L25 25 7.322 7.322Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#DEDDE0",
  d: "M29.348 20.652v5.435c0 3.328 4.348 4.348 4.348 4.348s4.348-1.02 4.348-4.348v-5.435h-8.696Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#786145",
  d: "M32.609 25.11h2.174v3.151h-2.174V25.11Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M35.87 23.913a2.174 2.174 0 1 0-4.348 0 1.087 1.087 0 0 0 0 2.174h4.348a1.087 1.087 0 0 0 0-2.174Z"
}));
FlagGQ.displayName = 'FlagGQ';
export default withFlagWrapper(FlagGQ);
//# sourceMappingURL=index.js.map